export function LandingHero() {
	return (
		<div className="mx-auto mb-10 max-w-[1400px] px-6 lg:px-12">
			<div className="mx-auto flex max-w-4xl flex-col items-center text-center">
				<div className="mb-6 flex items-center justify-center gap-3">
					<div className="bg-gold h-px w-8" />
					<span className="text-gold text-[10px] font-semibold tracking-[0.4em] uppercase">
						Deciphering the Noise
					</span>
					<div className="bg-gold h-px w-8" />
				</div>
				<h1 className="font-display mb-6 text-6xl leading-[1.1] md:text-8xl">
					Unlock the{" "}
					<span className="font-display italic">wisdom</span> <br />
					hidden in noise.
				</h1>
				<p className="text-ivory/70 mx-auto mb-8 max-w-2xl font-sans text-lg leading-relaxed font-light md:text-xl">
					Paste a YouTube URL and get structured insights instantly.
					Findings extracts claims, predictions, and disagreements
					from long-form content.
				</p>
			</div>
		</div>
	);
}
